/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { HttpHandler, HttpHeaderResponse, HttpInterceptor, HttpProgressEvent, HttpRequest, HttpResponse, HttpSentEvent, HttpUserEvent } from '@angular/common/http';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { Observable } from 'rxjs';

@Injectable()
export class AuthorizationHttpInterceptor implements HttpInterceptor {

  constructor(private $localStorage: LocalStorageService,
              private $sessionStorage: SessionStorageService) {

  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {
    // Skip JSONP requests (e.g., Google Maps API) - they don't support headers
    if (req.url.includes('callback=') || req.url.includes('maps.googleapis.com')) {
      return next.handle(req);
    }

    const token = this.$localStorage.retrieve('authenticationToken') || this.$sessionStorage.retrieve('authenticationToken');
    if (token) {
      const newReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
      return next.handle(newReq);
    } else {
      return next.handle(req);
    }
  }
}
